import React, { Fragment } from 'react';
import { Menu } from 'semantic-ui-react';
import AssigneeDropdown from '../../dropdowns/AssigneeDropdown';
import IdLabel from './IdLabel';

const AssigneeFilter = ({ assigneeIds = [], onFilterDelete, onFilterAdd }) => (
  <Fragment>
    <Menu.Item>Assignee</Menu.Item>
    <Menu.Item>
      <div>
        {assigneeIds.map(assigneeId => (
          <IdLabel key={assigneeId} userId={assigneeId} onFilterDelete={onFilterDelete} />
        ))}
      </div>
      <AssigneeDropdown value={null} onChange={onFilterAdd.bind(this, 'assigneeIds')} />
    </Menu.Item>
  </Fragment>
);

export default AssigneeFilter;



// WEBPACK FOOTER //
// ./src/component/TasksListComponents/AssigneeFilter/index.js